import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { usersApi } from '../../api/users';
import { battlesApi } from '../../api/battles';
import { forumApi } from '../../api';
import { battlePersonApi } from '../../api/battlePerson';
import HrnbCard from '../../components/controls/HrnbCard';
import HrnbLoader from '../../components/controls/HrnbLoader';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const [stats, setStats] = useState({
        totalUsers: 0,
        activeBattles: 0,
        pendingPosts: 0,
        pendingApplications: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadStats = async () => {
            try {
                // Загрузка статистики пользователей
                try {
                    const usersData = await usersApi.list();
                    const usersList = Array.isArray(usersData)
                        ? usersData
                        : (usersData?.content || []);
                    setStats(prev => ({ ...prev, totalUsers: usersList.length }));
                } catch (err) {
                    console.warn('[AdminDashboard] Failed to load users stats:', err.message);
                }

                // Загрузка статистики баттлов
                try {
                    const battlesData = await battlesApi.list({ size: 100 });
                    const battlesList = battlesData?.content || (Array.isArray(battlesData) ? battlesData : []);
                    const activeCount = battlesList.filter(b => b.status === 'ACTIVE').length;
                    setStats(prev => ({ ...prev, activeBattles: activeCount }));
                } catch (err) {
                    console.warn('[AdminDashboard] Failed to load battles stats:', err.message);
                }

                // Загрузка статистики постов на модерации
                try {
                    const postsData = await forumApi.listPosts({ size: 100 });
                    const postsList = postsData?.content || (Array.isArray(postsData) ? postsData : []);
                    const pendingCount = postsList.filter(p => p.status === 'MODERATED').length;
                    setStats(prev => ({ ...prev, pendingPosts: pendingCount }));
                } catch (err) {
                    console.warn('[AdminDashboard] Failed to load posts stats:', err.message);
                }

                // Загрузка статистики заявок
                try {
                    const applicationsData = await battlePersonApi.list({ status: 'PENDING' });
                    setStats(prev => ({
                        ...prev,
                        pendingApplications: Array.isArray(applicationsData) ? applicationsData.length : 0
                    }));
                } catch (err) {
                    console.warn('[AdminDashboard] Failed to load applications stats:', err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        loadStats();
    }, []);

    if (loading) {
        return (
            <Container fluid className="admin-loading">
                <HrnbLoader />
            </Container>
        );
    }

    return (
        <Container fluid>
            <h1 className="admin-page-title">Административная панель</h1>
            
            <Row className="admin-dashboard-stats">
                <Col md={3} sm={6} className="mb-3">
                    <HrnbCard className="admin-stat-card">
                        <div className="admin-stat-icon">👥</div>
                        <div className="admin-stat-content">
                            <h3>Пользователи</h3>
                            <p className="admin-stat-value">{stats.totalUsers}</p>
                            <small>Всего</small>
                        </div>
                    </HrnbCard>
                </Col>
                
                <Col md={3} sm={6} className="mb-3">
                    <HrnbCard className="admin-stat-card">
                        <div className="admin-stat-icon">⚔️</div>
                        <div className="admin-stat-content">
                            <h3>Баттлы</h3>
                            <p className="admin-stat-value">{stats.activeBattles}</p>
                            <small>Активных</small>
                        </div>
                    </HrnbCard>
                </Col>
                
                <Col md={3} sm={6} className="mb-3">
                    <HrnbCard className="admin-stat-card">
                        <div className="admin-stat-icon">📝</div>
                        <div className="admin-stat-content">
                            <h3>Посты</h3>
                            <p className="admin-stat-value">{stats.pendingPosts}</p>
                            <small>На модерации</small>
                        </div>
                    </HrnbCard>
                </Col>
                
                <Col md={3} sm={6} className="mb-3">
                    <HrnbCard className="admin-stat-card">
                        <div className="admin-stat-icon">⏰</div>
                        <div className="admin-stat-content">
                            <h3>Заявки</h3>
                            <p className="admin-stat-value">{stats.pendingApplications}</p>
                            <small>Ожидают</small>
                        </div>
                    </HrnbCard>
                </Col>
            </Row>

            <Row>
                <Col md={8}>
                    <HrnbCard title="Последние действия">
                        <p className="text-muted">Здесь будет отображаться история действий администраторов</p>
                    </HrnbCard>
                </Col>
                
                <Col md={4}>
                    <HrnbCard title="Быстрые действия">
                        <div className="admin-quick-actions">
                            <Button variant="primary" className="mb-2" as="a" href="/admin/battles">
                                Создать баттл
                            </Button>
                            <Button variant="secondary" className="mb-2" as="a" href="/admin/users">
                                Добавить пользователя
                            </Button>
                            <Button variant="info" className="mb-2" as="a" href="/admin/battles/participants">
                                Модерация заявок
                            </Button>
                            <Button variant="success" className="mb-2" as="a" href="/admin/forum/posts">
                                Модерация постов
                            </Button>
                            <Button variant="warning" className="mb-2" as="a" href="/admin/forum/categories">
                                Управление категориями
                            </Button>
                        </div>
                    </HrnbCard>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminDashboard;
